import React, { FC } from 'react';
import classNames from 'classnames';

import { UiButton } from 'src/components/UI/Button';
import styles from './styles.module.scss';
import { IconMenu, IconMenuClose } from './icons';

type Props = {
  isHidden: boolean;
  showMenu: boolean;
  onToggleMenu: () => void;
};

export const ToggleButton: FC<Props> = ({ isHidden, showMenu, onToggleMenu }) => (
  <UiButton
    className={classNames(styles.toggleBtn, isHidden && styles.isHidden)}
    onClick={onToggleMenu}
    dataTest="leftSideMenuIcon"
  >
    {showMenu ? <IconMenuClose className={styles.toggleMenuIcon} /> : <IconMenu className={styles.toggleMenuIcon} />}
  </UiButton>
);
